import { render } from "./IncomesBySource.vue?vue&type=template&id=60621674&scoped=true"
import script from "./IncomesBySource.vue?vue&type=script&lang=js"
export * from "./IncomesBySource.vue?vue&type=script&lang=js"

import "./IncomesBySource.vue?vue&type=style&index=0&id=60621674&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/sparta-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60621674"]])

export default __exports__